<template>
    <section class="fullimage">
      <video autoplay="autoplay" muted loop controls width="100%">
        <source type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' src="@/assets/videos/in_dev.mp4">
      </video>
      <ModalLater :title="title" :content="content" />
    </section>
</template>

<script>
import ModalLater from "@/components/Modals/ModalLater";

export default {
  name: "Shop",
  components: {
    ModalLater
  },
  data: () => ({
    pins: [],
    panel: false,
    workplace: false,
    title: 'Этот раздел сейчас в разработке',
    content: '<p>Прошу прощения, раздел нуждается в переработке. Когда нибудь он снова заработает.</p>'
  })
};
</script>
<style>
  .fullimage {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    position: relative;
    background-color: #020102;
  }
  .fullimage img {
    width: 100%;
  }
</style>